import Select from "./Select";
import SelectStatus from "./SelectStatus";

export { Select, SelectStatus };

export default Select;
